// Core
import { Injectable } from '@angular/core';

//Entities
import { IPopupOptions, IPopupButton } from './entities';

@Injectable()
export class PopupOptions implements IPopupOptions {
  width: string = '600px';
  popupClass: string = 'popup-box';
  showTitle: boolean = true;
  showMessage: boolean = true;
  showCloseBtn: boolean = true;
  injectComponent: any = void 0;
  actionButtons: Array<IPopupButton> = [
    {
      text: 'Cancel',
      buttonClasses: 'btn-cancel',
      onAction: () => {
        return false;
      }
    },
    {
      text: 'Ok',
      buttonClasses: 'btn-ok',
      onAction: () => {
        return true;
      }
    }
  ];
  animate: string = 'slide-from-right';
  position: string = 'center'; // top, bottom, center
  showOverlay: boolean = true;
  closeOnOverlay: boolean = true;
  callback: Function = (result: any) => {};
  constructor() {}
}
